import React from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader } from '../../components'
import { MainContent, MainContentMobile } from './components'
import atf from '../../database/pages/atf.json'

const Organization = () => {
  return (
    <DefaultLayout>
      <SimplePageHeader
        title="Organizations"
        description={atf.organization}
        largePadding
      />
      {/* <PageHeader
        title="Organization"
        description="The platform for civil society organisations and government agencies to share their knowledge, expertise and experiences in promoting P/CVE sector reform in Indonesia."
        image="/images/headers/khub_organization.svg"
      /> */}

      {/* MOBILE & TABLET*/}
      <div className="lg:hidden">
        <MainContentMobile />
      </div>

      {/* DESKTOP */}
      <MainContent />
    </DefaultLayout>
  )
}

export { Organization }
